import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListLocations from "../../../../components/@locations/locations/ListLocations";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function LocationsPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListLocations
                routeType={routeType}
            />
        </SettingFrame>
    )
}